export default "__VITE_ASSET__ELAV1FFe__"